export const STOREFRONT_LANGUAGES = [
  { code: "en", name: "English" },
  { code: "de", name: "German" },
  { code: "es", name: "Spanish" },
  { code: "pt", name: "Portuguese" },
];

export const STOREFRONT_LANGUAGE_CODES = STOREFRONT_LANGUAGES.map((lang) => lang.code);

export function normalizeStoreLanguage(code) {
  const value = String(code || "en").toLowerCase();
  return STOREFRONT_LANGUAGES.some((lang) => lang.code === value) ? value : "en";
}

export function languageDisplayName(code) {
  const normalized = normalizeStoreLanguage(code);
  return STOREFRONT_LANGUAGES.find((lang) => lang.code === normalized)?.name || normalized;
}

/**
 * Languages shown in the storefront switcher.
 * Always includes the catalog/default language. Defaults to all supported langs when unset.
 */
export function normalizeEnabledLanguages(value, defaultLanguage = "en") {
  const source = normalizeStoreLanguage(defaultLanguage);
  const raw = Array.isArray(value)
    ? value.map((code) => String(code || "").toLowerCase()).filter((code) => STOREFRONT_LANGUAGE_CODES.includes(code))
    : [...STOREFRONT_LANGUAGE_CODES];
  const unique = [...new Set(raw)];
  if (!unique.includes(source)) unique.unshift(source);
  if (!unique.length) unique.push(source);
  return STOREFRONT_LANGUAGE_CODES.filter((code) => unique.includes(code));
}

export function translationTargetLanguages(sourceLanguage) {
  const source = normalizeStoreLanguage(sourceLanguage);
  return STOREFRONT_LANGUAGES.filter((lang) => lang.code !== source);
}

export function suggestLanguageForCountry(country) {
  const normalized = String(country || "").trim().toLowerCase();
  if (!normalized) return "en";
  if (normalized.includes("germany") || normalized.includes("deutsch") || normalized === "de" || normalized.includes("austria") || normalized.includes("switzerland")) {
    return "de";
  }
  if (normalized.includes("portugal") || normalized.includes("brazil") || normalized === "pt") return "pt";
  if (normalized.includes("spain") || normalized.includes("mexico") || normalized.includes("argentina") || normalized === "es") return "es";
  return "en";
}
